import React from 'react';

const AllowedExtraTimeIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 26 23">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g transform="translate(-651 -62) translate(634 64) translate(19.5)">
              <circle cx="9.5" cy="9.5" r="10.5" fill="#2B73C7" stroke="#2B73C7" strokeWidth="2" />
              <g stroke="#FFF">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.55 3.8L9.55 9.495 12.75 11.8" />
                <g>
                  <g>
                    <circle cx="9.5" cy="9.5" r="9.5" />
                  </g>
                  <path fill="#2B73C7" fillRule="nonzero" d="M19.3-.5h-2.6v3.2h-3.2v2.6h3.2v3.2h2.6V5.3h3.2V2.7h-3.2V-.5z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default AllowedExtraTimeIcon;
